import React from "react";
import { NavLink } from "react-router-dom";

const services = [
  {
    count: 1,
    title: "Heating Ventilation & Air Conditioning(HVAC)",
    flaticon: "flaticon-city",
    description:
      "HVAC systems regulate indoor climate by controlling temperature, humidity, and air quality, ensuring optimal comfort and energy efficiency.",
  },
  {
    count: 2,
    title: "Indoor Air Quality(IAQ)",
    flaticon: "flaticon-paint",
    description:
      "Indoor Air Quality (IAQ) is the air quality within buildings, essential for health and comfort; maintain it with proper ventilation and filtration.",
  },
  {
    count: 3,
    title: "Electrical & Instrumentation(ETC)",
    flaticon: "flaticon-crane",
    description:
      "Electrical & Instrumentation (E&I) involves designing and maintaining electrical systems and instruments to ensure safety and efficiency in industrial processes.",
  },
  {
    count: 4,
    title: "Interior",
    flaticon: "flaticon-decorating",
    description:
      "lorem Ipsum available, but the majority have suffered alterati on in some form, by ious by accident.",
  },
  {
    count: 5,
    title: "Fire Protection & Security(FPS)",
    flaticon: "flaticon-chart",
    description:
      "Fire Protection & Security (FPS) focuses on implementing systems and measures to prevent, detect, and respond to fire hazards while ensuring the safety and security of buildings and occupants.",
  },
  {
    count: 6,
    title: "Integrated Building Management(BMS)",
    flaticon: "flaticon-sketch",
    description:
      "Integrated Building Management (BMS) involves using centralized systems to monitor and control building operations, including HVAC, lighting, security, and energy management, enhancing efficiency, safety, and comfort.",
  },
  {
    count: 7,
    title: "Public Health Engineering(PHE)",
    flaticon: "flaticon-builder",
    description:
      "Public Health Engineering (PHE) focuses on designing and managing systems for safe water supply, sanitation, and waste management, ensuring public health and environmental protection.",
  },
  {
    count: 8,
    title: "Steel Fabrication Work(SFW)",
    flaticon: "flaticon-drill",
    description:
      "Steel Fabrication Work (SFW) involves cutting, shaping, and assembling steel structures to meet specific design requirements, ensuring durability and strength for various construction projects.",
  },
  {
    count: 9,
    title: "Steam,Hot Water and Condonation(SHC)",
    flaticon: "flaticon-art-and-design",
    description:
      "Efficiently generate steam and hot water while managing condensation to optimize heating performance in industrial systems.",
  },
];

var img1 = require("./../../images/background/bg-5.png");
var img2 = require("./../../images/background/line.png");

class OurServices3 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/masonary.js");
  }
  render() {
    return (
      <>
        <div
          className="section-full p-t80 p-b50 bg-white mobile-page-padding"
          style={{ backgroundImage: "url(" + img1 + ")" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="mt-separator-outer separator-center">
                <div className="mt-separator">
                  <h2 className="text-uppercase sep-line-one ">
                    <span className="font-weight-300 text-primary">All</span>{" "}
                    Services
                  </h2>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            {/* IMAGE CAROUSEL START */}
            <div className="section-content">
              <div className="row">
                {services.map((item, index) => (
                  <div key={index} className="col-md-4 col-sm-6">
                    <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white">
                      <div
                        className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary  scale-in-center bg-moving"
                        style={{ backgroundImage: "url(" + img2 + ")" }}
                      >
                        <span className="icon-cell text-secondry">
                          <i className={item.flaticon} />
                        </span>
                      </div>
                      <div className="icon-content">
                        <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">
                          {item.title}
                        </h4>
                        <p>{item.description}</p>
                        <NavLink
                          to={"/services"}
                          className="site-button-link"
                          data-hover="Read More"
                        >
                          Read More{" "}
                          <i className="fa fa-angle-right arrow-animation" />
                        </NavLink>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default OurServices3;
